import api from 'app/api';
import { getUseCases } from 'app/api/Usecase';

import {
  SAVE_FILE_SET_TABLE_STRUCTURE,
  SAVE_LOT_TABLE_STRUCTURE,
  SAVE_USECASE_ROUTING_DATA_TABLE_STRUCTURE,
  SAVE_WAFER_TABLE_STRUCTURE,
  SET_IMAGE_FIT,
  SET_LAST_SELECTED_DEFECT,
  SET_MODEL_DICT,
  SET_MODEL_DICT_LOADING,
  SET_USE_CASE_DICT,
  SET_USE_CASE_DICT_LOADING,
  SET_WAFER_DICT,
  SET_WAFER_DICT_LOADING,
  UPDATE_USECASE_BY_ID,
} from './constants';

export const setUsecaseDict = subscriptionId => {
  return dispatch => {
    dispatch({ type: SET_USE_CASE_DICT_LOADING, payload: true });
    return getUseCases({
      baseParams: {
        subscription_id: subscriptionId,
        get_all_records: true,
      },
    }).then(res => {
      dispatch({ type: SET_USE_CASE_DICT, payload: res?.results || [] });
    });
  };
};

export const updateUseCaseById = usecase => ({
  type: UPDATE_USECASE_BY_ID,
  payload: usecase,
});

export const setWafersDict = () => {
  return dispatch => {
    dispatch({ type: SET_WAFER_DICT_LOADING, payload: true });
    return api.getWaferMap('wafers', undefined, true).then(res => {
      dispatch({ type: SET_WAFER_DICT, payload: res?.results || [] });
    });
  };
};

export const setModelsDict = (subscriptionId, ids = []) => {
  return dispatch => {
    dispatch({ type: SET_MODEL_DICT_LOADING, payload: true });
    return api
      .getMlModels('models', subscriptionId, false, ids.join(','))
      .then(res => {
        dispatch({ type: SET_MODEL_DICT, payload: res });
      });
  };
};

export const SaveWaferTableStructure = payload => {
  return { type: SAVE_WAFER_TABLE_STRUCTURE, payload };
};

export const setImageFit = payload => {
  return { type: SET_IMAGE_FIT, payload };
};
export const saveLotTableStructure = payload => {
  return { type: SAVE_LOT_TABLE_STRUCTURE, payload };
};

export const saveFileSetTableStructure = payload => {
  return { type: SAVE_FILE_SET_TABLE_STRUCTURE, payload };
};

export const setLastSelectedDefect = payload => {
  return { type: SET_LAST_SELECTED_DEFECT, payload };
};

export const SaveUsecaseRoutingTableStructure = payload => {
  return { type: SAVE_USECASE_ROUTING_DATA_TABLE_STRUCTURE, payload };
};
